function TempPayoutValidationList() {
    return 'Under construction'
}

export default TempPayoutValidationList
